/**
 * @generated SignedSource<<e60492228e874c55c3cd89b2173c6508>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftItemTileContent_nftItem$data = {
  readonly serviceId: string | null;
  readonly wasBurned: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"BurnedItemTileContent_nftItem" | "CollectorTileContent_nftItem" | "CreatorContent_nftItem" | "RegularTileContent_nftItem">;
  readonly " $fragmentType": "NftItemTileContent_nftItem";
};
export type NftItemTileContent_nftItem$key = {
  readonly " $data"?: NftItemTileContent_nftItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftItemTileContent_nftItem">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftItemTileContent_nftItem",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "wasBurned",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RegularTileContent_nftItem"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CreatorContent_nftItem"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BurnedItemTileContent_nftItem"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CollectorTileContent_nftItem"
    }
  ],
  "type": "NftItem",
  "abstractKey": null
};

(node as any).hash = "246d4b11b4c4c54b1076a92ad71d731d";

export default node;
